import { zodResolver } from '@hookform/resolvers/zod';
import { Grid, Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { LoginMethodField } from '../components/form/LoginMethodField';
import { NameField } from '../components/form/name.field';
import { SurnameField } from '../components/form/surname.field';
import { UserGroupField } from '../components/form/UserGroupField';
import { UserRoleField } from '../components/form/UserRoleField';
import { UsersAddValues, usersAddSchema } from './createUserForm.schema';
import { defaultUsersAddValues } from './createUserForm.values';

interface Props {
  values?: UsersAddValues;
  onSubmit: (data: UsersAddValues) => Promise<any>;
}

export function CreateUserForm({ values, onSubmit }: Props) {
  const { $t } = useIntl();
  return (
    <FormContainer
      defaultValues={defaultUsersAddValues}
      values={values}
      onSuccess={onSubmit}
      resolver={zodResolver(usersAddSchema)}
    >
      <Stack spacing={4} useFlexGap>
        <Grid container>
          <Grid item md={4}>
            <TextFieldElement
              name="email"
              label={$t({
                id: 'common.email',
                defaultMessage: 'Email',
              })}
              fullWidth
              required
            />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item md={12}>
            <LoginMethodField />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item md={3}>
            <NameField />
          </Grid>
          <Grid item md={3}>
            <SurnameField />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item md={5}>
            <UserRoleField />
          </Grid>
          <Grid item md={5}>
            <UserGroupField />
          </Grid>
        </Grid>

        <FormActionsMui />
      </Stack>
    </FormContainer>
  );
}
